import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { changeTitle } from "./../../modules/navigation";
import DashboardView from "./DashboardView";

import "./Dashboard.css";

class Dashboard extends React.Component {
  componentDidMount() {
    this.props.changeTitle("Dashboard");
  }

  render() {
    return <DashboardView {...this.props} />;
  }
}

const mapStateToProps = state => {
  return {
    lang: state.internationalization.lang
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changeTitle
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Dashboard);



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Dashboard.js